(function(){
'use strict';

angular.module('classy').run(['$templateCache', function ($templateCache) {
  $templateCache.put('global/flows/create-fundraising-team/views/wait', '<div class="create-flow"\n' + 'data-ng-class="{processing: ui.processing}">\n' + '\n' + '  <h2 class="create-flow_title">Please wait ...</h1>\n' + '\n' + '  <div class="create-flow_waiting">\n' + '    <div class="create-flow_waiting-spinner" \n' + '    data-ng-style="{color: ui.primaryColor}"></div>\n' + '  </div>\n' + '\n' + '</div>');
}]);
})();